import { render, staticRenderFns } from "./DeviceLayoutXuefengshanGlobal.vue?vue&type=template&id=048d1524&scoped=true"
import script from "./DeviceLayoutXuefengshanGlobal.vue?vue&type=script&lang=js"
export * from "./DeviceLayoutXuefengshanGlobal.vue?vue&type=script&lang=js"
import style0 from "./DeviceLayoutXuefengshanGlobal.vue?vue&type=style&index=0&id=048d1524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d1524",
  null
  
)

export default component.exports